module.exports = __webpack_public_path__ + "img/download-logo.a104c523.svg";